/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ChatRoomProvider, useChatClient } from '@ably/chat/react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as chatActions from '../store/Chat.action';
import useChatNotifications from '../../../hooks/useChatNotifications';
import ChatMessages from './ChatMessages';
import unreadBell from '../../../assets/images/bell.svg';
import chatIcon from '../../../assets/images/chat-icon.png';
import { getSupplierUserById } from '../../../services/supplier.service';
import { fetchProductname } from '../../DevlopmentOrder/store/DevelopmentOrder.action';

function ChatRoom({
  samplesList,
  selectedSample,
  setSelectedSample,
  currentUser,
  isDetailsPage,
  onChatError,
  onResetSamples,
  moduleKey,
  activeTab,
  paddingBottom,
}) {
  const { t } = useTranslation('modules/chat');
  const [roomState, setRoomState] = useState({
    isExpanded: false,
    supplierList: [],
    activeRoomName: null,
    searchedText: '',
    mentionsUsers: [{ id: 'all', display: 'all', firstName: 'all', lastName: 'all', image: null }],
  });
  const chatLabel = 'CHAT.ROOMS.DEFAULT_INTERNAL';
  const [selectedSupplier, setSelectedSupplier] = useState({ label: t(chatLabel), value: 'default' });
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [hasUnread, setHasUnread] = useState(false);
  const [unreadSuppliers, setUnreadSuppliers] = useState(new Set());
  const [unreadSamples, setUnreadSamples] = useState(new Set());

  const { isExpanded, activeRoomName } = roomState;
  const params = useParams();
  const devOrderId = params?.devOrderId;
  const reducer = useSelector((reducerState) => reducerState);
  const { BOMConfigDetails, Measuremets } = reducer;
  const { productDetails, suppliers } = BOMConfigDetails;
  const { productName } = Measuremets;

  const dispatch = useDispatch();
  const isSupplierLoggedIn = currentUser?.role === 'Supplier';
  const supplierRequiredList = ['Costing', 'samples', 'BOM', 'SPEC', 'TESTING', 'DESIGN_DETAIL', 'CARE_USER_INSTRUCTION', 'PURCHASE_ORDER'];
  const isSupplierRequired = supplierRequiredList.includes(moduleKey);
  const chatClient = useChatClient();
  const getCustomSelectStyles = (selectedValue, type = 'supplier') => {
    let backgroundColor = '#ffffff';
    let color = '#FFF';

    if (type === 'supplier') {
      if (selectedValue?.value === 'default') {
        backgroundColor = '#4f9f79';
      } else if (selectedValue?.value) {
        backgroundColor = '#1E90FF';
      }
    } else if (type === 'sample' && selectedValue?._id) {
      backgroundColor = '#D9D9D9';
      color = '#000 !important';
    }

    return {
      control: (provided) => ({
        ...provided,
        backgroundColor,
        color,
        borderRadius: '25px',
        boxShadow: '-0.5px -0.5px 1px 0px #FFFFFF40 inset, 0.5px 0.5px 3px 0px #00000040 inset',
        border: 'none',
        minHeight: '28px',
        '&:hover': {
          backgroundColor,
        },
      }),
      singleValue: (provided) => {
        return { ...provided, color };
      },
      valueContainer: (provided) => ({
        ...provided,
        height: '28px',
      }),
      indicatorSeparator: () => ({
        display: 'none',
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0 10px',
      }),
      menu: (provided) => ({
        ...provided,
        margin: 0,
        boxShadow: '0px 1px 2px 0px #00000040',
        borderRadius: '25px',
        overflow: 'hidden',
        padding: '8px',
      }),
      option: (provided, state) => ({
        ...provided,
        padding: '6px 12px',
        borderRadius: '25px',
        marginBottom: '4px',
        backgroundColor: state.isSelected ? '#D9D9D9' : provided.backgroundColor,
        color: state.isSelected ? '#000' : provided.color,
        '&:hover': {
          backgroundColor: state.isSelected ? '#D9D9D9' : '#f5f5f5',
        },
      }),
    };
  };

  const sampleSelectStyles = useMemo(() => getCustomSelectStyles(selectedSample, 'sample'), [selectedSample]);
  const supplierSelectStyles = useMemo(() => getCustomSelectStyles(selectedSupplier, 'supplier'), [selectedSupplier]);

  const computedRoomName = useMemo(() => {
    switch (moduleKey) {
      case 'Costing':
        if (selectedSupplier && selectedSupplier?.value !== 'default') {
          return `costing-${devOrderId}-supplier-${selectedSupplier?.value}`;
        }
        if (selectedSupplier?.value === 'default' && selectedSample?._id) {
          return `costing-${devOrderId}-default`;
        }
        return null;
      case 'samples':
        if (selectedSupplier && selectedSupplier?.value !== 'default') {
          return `sample-${devOrderId}-supplier-${selectedSupplier?.value}`;
        }
        if (selectedSupplier?.value === 'default' && selectedSample?._id) {
          return `sample-${devOrderId}-default`;
        }
        return null;
      case 'placeholder':
        if (!selectedSample?._id) return null;
        return `placeholder-${selectedSample?._id}`;

      case 'BOM':
        if (selectedSupplier && selectedSupplier?.value !== 'default') {
          return `BOM-${devOrderId}-supplier-${selectedSupplier?.value}`;
        }
        if (selectedSupplier?.value === 'default') {
          return `BOM-${devOrderId}-default`;
        }
        return null;
      case 'TESTING': {
        if (selectedSupplier && selectedSupplier?.value !== 'default') {
          return `TESTING-${devOrderId}-supplier-${selectedSupplier?.value}`;
        }
        if (selectedSupplier?.value === 'default') {
          return `TESTING-${devOrderId}-default`;
        }
        return null;
      }
      case 'SPEC':
        if (selectedSupplier && selectedSupplier?.value !== 'default') {
          return `SPEC-${devOrderId}-supplier-${selectedSupplier?.value}`;
        }
        if (selectedSupplier?.value === 'default') {
          return `SPEC-${devOrderId}-default`;
        }
        return null;
      case 'DESIGN_DETAIL': {
        if (selectedSupplier && selectedSupplier?.value !== 'default') {
          return `DESIGN_DETAIL-${devOrderId}-supplier-${selectedSupplier?.value}`;
        }
        if (selectedSupplier?.value === 'default') {
          return `DESIGN_DETAIL-${devOrderId}-default`;
        }
        return null;
      }
      case 'CARE_USER_INSTRUCTION': {
        if (selectedSupplier && selectedSupplier?.value !== 'default') {
          return `CARE_USER_INSTRUCTION-${devOrderId}-supplier-${selectedSupplier?.value}`;
        }
        if (selectedSupplier?.value === 'default') {
          return `CARE_USER_INSTRUCTION-${devOrderId}-default`;
        }
        return null;
      }
      case 'PURCHASE_ORDER': {
        if (selectedSupplier && selectedSupplier?.value !== 'default') {
          return `PURCHASE_ORDER-${devOrderId}-supplier-${selectedSupplier?.value}`;
        }
        if (selectedSupplier?.value === 'default' && selectedSample?._id) {
          return `PURCHASE_ORDER-${devOrderId}-default`;
        }
        return null;
      }
      case 'ProductInfoList':
        return 'ProductInfoList-default';
      default:
        return null;
    }
  }, [moduleKey, devOrderId, selectedSupplier?.value, selectedSample?._id]);

  useEffect(() => {
    const id = setTimeout(() => {
      setDebouncedSearch((roomState.searchedText || '').trim());
    }, 300);
    return () => clearTimeout(id);
  }, [roomState.searchedText]);

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const objGetUsers = {
          module: moduleKey,
        };
        if (moduleKey === 'placeholder') {
          objGetUsers.devOrderId = null;
          objGetUsers.mainModule = 'placeholder';
        } else if (moduleKey === 'ProductInfoList') {
          objGetUsers.devOrderId = null;
          objGetUsers.mainModule = 'products';
        } else {
          objGetUsers.devOrderId = devOrderId;
          objGetUsers.mainModule = 'products';
        }
        const resp = await dispatch(chatActions.fetchChatUsersList(objGetUsers));
        const users = resp?.data?.users || [];
        const mapped = users.map((u) => ({
          id: u._id,
          display: u.fullName,
          firstName: u.firstName,
          lastName: u.lastName,
          image: u.image,
        }));
        setRoomState((prev) => {
          const allEntry = prev.mentionsUsers.find((user) => user.id === 'all');
          const supplierEntries = prev.mentionsUsers.filter(
            (user) => user.supplierUserAdded === true || user.supplierDynamicallyAdded === true
          );
          return {
            ...prev,
            mentionsUsers: [...(allEntry ? [allEntry] : []), ...mapped, ...supplierEntries],
          };
        });
      } catch (_e) {}
    };
    loadUsers();
  }, [devOrderId]);

  // Supplier options for dropdown
  const supplierOptions = useMemo(() => {
    const base = [{ label: t(chatLabel), value: 'default' }];

    switch (moduleKey) {
      case 'Costing': {
        if (selectedSample?.status === 'Draft') {
          return base;
        }
        if (selectedSample?.supplierName) {
          return base.concat([{ value: selectedSample.supplierName.supplierId, label: selectedSample.supplierName.supplierName }]);
        }
        const uniqueById = new Map();
        (samplesList || []).forEach((c) => {
          if (c.status === 'Draft') return;
          const sup = c?.productInfo?.supplierId || c?.supplierName;
          if (!sup) return;
          const id = String(sup?.supplierId || sup?._id || sup?.companies?._id || '');
          if (!id) return;
          const label = sup?.supplierName || sup?.name || t(chatLabel);
          if (!uniqueById.has(id)) {
            uniqueById.set(id, { value: id, label });
          }
        });
        const all = Array.from(uniqueById.values()).sort((a, b) => a.label.localeCompare(b.label));
        return base.concat(all);
      }
      case 'TESTING':
      case 'SPEC':
      case 'DESIGN_DETAIL':
      case 'CARE_USER_INSTRUCTION': {
        if (productName?.suppliers?.length > 0) {
          return base.concat(productName?.suppliers?.map((s) => ({ value: s?._id, label: s?.name })));
        }
        return base;
      }
      case 'BOM': {
        if (suppliers?.length > 0) {
          return base.concat(suppliers?.map((s) => ({ value: s._id, label: s.name })));
        }
        return base;
      }
      case 'PURCHASE_ORDER': {
        if (selectedSample?.status === 'Draft') {
          return base;
        }
        if (selectedSample?.supplierId) {
          return base.concat([{ value: selectedSample.supplierId?._id, label: selectedSample.supplierId?.supplierName }]);
        }

        const uniqueById = new Map();
        (samplesList || []).forEach((sampleData) => {
          const id = sampleData?.supplierId?._id;
          const label = sampleData?.supplierId?.supplierName;
          if (!id || !label) return;
          if (!uniqueById.has(id)) {
            uniqueById.set(id, { value: id, label });
          }
        });
        const all = Array.from(uniqueById.values()).sort((a, b) => a.label.localeCompare(b.label));
        return base.concat(all);
      }
      case 'samples':
      default: {
        if (selectedSample?.supplier && selectedSample?.supplierName) {
          return base.concat([{ value: selectedSample.supplier, label: selectedSample.supplierName }]);
        }
        const uniqueById = new Map();
        (samplesList || []).forEach((s) => {
          const id = s?.supplier;
          const label = s?.supplierName;
          if (!id || !label) return;
          if (!uniqueById.has(id)) {
            uniqueById.set(id, { value: id, label });
          }
        });
        const all = Array.from(uniqueById.values()).sort((a, b) => a.label.localeCompare(b.label));
        return base.concat(all);
      }
    }
  }, [moduleKey, samplesList, selectedSample, t, suppliers, productName]);

  const detachAndRelease = React.useCallback(
    async (name) => {
      try {
        if (!chatClient || !name) return;
        const room = await chatClient.rooms.get(name);
        try {
          await room.detach();
        } catch (_e) {}
        await chatClient.rooms.release(name);
      } catch (_e) {}
    },
    [chatClient],
  );

  const prevRoomRef = useRef(null);
  useEffect(() => {
    if (prevRoomRef.current && prevRoomRef.current !== activeRoomName) {
      detachAndRelease(prevRoomRef.current);
    }
    prevRoomRef.current = activeRoomName || null;
  }, [activeRoomName, detachAndRelease]);

  const extractSupplierIdFromRoomName = (roomName) => {
    try {
      if (!roomName?.includes('supplier-')) {
        return null;
      }

      // Room pattern: {module}-{entityId}-supplier-{supplierId}
      const parts = roomName.split('-');
      const supplierIndex = parts.findIndex((part) => part === 'supplier') + 1;

      if (supplierIndex > 0 && parts[supplierIndex]) {
        return parts[supplierIndex];
      }

      return null;
    } catch (error) {
      console.error('Error extracting supplier ID from room name:', error);
      return null;
    }
  };

  // Listen for cross-room unread notifications (no duplicate toasts)
  let userId = currentUser?.userId;
  if (currentUser?.supplierUserId) {
    userId = currentUser?.supplierUserId;
  }
  useChatNotifications(userId, activeRoomName, selectedSample?._id, {
    showToast: false,
    isChatOpen: isExpanded,
    onUnread: (data) => {
      const isCurrentModule = data?.module?.toLowerCase() === moduleKey?.toLowerCase();
      const isDevOrderId = data?.devOrderId === devOrderId;
      const isProductIDNotRequired = ['ProductInfoList', 'placeholder'].includes(data?.module);

      if (!isProductIDNotRequired && (!isCurrentModule || !isDevOrderId)) {
        return;
      }

      if (data?.moduleRefId) {
        const activeModulePrimaryList = samplesList?.filter((s) => s?._id === data?.moduleRefId);
        if (!activeModulePrimaryList || activeModulePrimaryList.length === 0) {
          setHasUnread(false);
        } else {
          setHasUnread(true);
        }
      } else if (isDetailsPage && !data?.moduleRefId) {
        setHasUnread(false);
      } else {
        setHasUnread(true);
      }

      const supplierId = extractSupplierIdFromRoomName(data?.roomName);

      if (supplierId) {
        setUnreadSuppliers((prev) => {
          const next = new Set(prev);
          next.add(String(supplierId));
          return next;
        });
      }

      let targetSampleId = data?.moduleRefId || null;
      if (!targetSampleId && data?.roomName && Array.isArray(samplesList)) {
        const match = samplesList.find((s) => data.roomName.includes(String(s?._id)));
        if (match?._id) targetSampleId = String(match._id);
      }
      if (targetSampleId) {
        setUnreadSamples((prev) => {
          const next = new Set(prev);
          next.add(String(targetSampleId));
          return next;
        });
      }
    },
  });
  // Stable key for samples list to avoid effect re-runs on shallow prop identity changes
  const samplesListIdsKey = useMemo(() => {
    return JSON.stringify(Array.isArray(samplesList) ? (samplesList || []).map((s) => s?._id) : []);
  }, [samplesList]);

  useEffect(() => {
    let cancelled = false;
    const primeUnread = async () => {
      if (!devOrderId && !Array.isArray(samplesList) && moduleKey !== 'ProductInfoList') return;
      try {
        const resp = await dispatch(chatActions.fetchUnreadMessages({ module: moduleKey, devOrderId }));
        const msgs = resp?.data?.messages || [];
        if (cancelled || msgs.length === 0) return;
        const arrayOfModuleRefIds = msgs.map((m) => m?.data?.moduleRefId).filter((id) => id !== null && id !== undefined && id !== '');

        const activeModulePrimaryList = samplesList?.filter((s) => arrayOfModuleRefIds.includes(s?._id));

        if (!msgs || msgs?.length === 0) {
          setHasUnread(false);
        }
        if (isDetailsPage && arrayOfModuleRefIds?.length === 0) {
          setHasUnread(false);
        } else if (arrayOfModuleRefIds && arrayOfModuleRefIds?.length === 0 && msgs?.length > 0) {
          setHasUnread(true);
        }
        if (arrayOfModuleRefIds && arrayOfModuleRefIds?.length > 0 && activeModulePrimaryList?.length > 0) {
          setHasUnread(true);
        }
        if (arrayOfModuleRefIds && arrayOfModuleRefIds?.length > 0 && activeModulePrimaryList?.length === 0) {
          setHasUnread(false);
        }

        msgs.forEach((m) => {
          const data = m?.data || {};
          const supplierId = extractSupplierIdFromRoomName(data?.roomName);

          if (supplierId) {
            setUnreadSuppliers((prev) => {
              const next = new Set(prev);
              next.add(String(supplierId));
              return next;
            });
          }
          let targetSampleId = data?.moduleRefId || null;
          if (!targetSampleId && data?.roomName && Array.isArray(samplesList)) {
            const match = samplesList.find((s) => data.roomName.includes(String(s?._id)));
            if (match?._id) targetSampleId = String(match._id);
          }
          if (targetSampleId) {
            setUnreadSamples((prev) => {
              const next = new Set(prev);
              next.add(String(targetSampleId));
              return next;
            });
          }
        });
      } catch (_e) {}
    };

    primeUnread();
    return () => {
      cancelled = true;
    };
  }, [devOrderId, moduleKey, samplesListIdsKey, activeTab]);

  useEffect(() => {
    if (computedRoomName === activeRoomName) return;
    setRoomState((prev) => ({ ...prev, activeRoomName: null }));
    const id = setTimeout(() => setRoomState((prev) => ({ ...prev, activeRoomName: computedRoomName })), 0);
    return () => clearTimeout(id);
  }, [computedRoomName, activeRoomName]);

  useEffect(() => {
    return () => {
      if (prevRoomRef.current) detachAndRelease(prevRoomRef.current);
    };
  }, [detachAndRelease]);

  useEffect(() => {
    if (!isExpanded || !activeRoomName) return;

    dispatch(chatActions.markMessagesAsRead(activeRoomName, selectedSample?._id));
    setHasUnread(false);

    if (roomState.searchedText !== '' && !selectedSample?._id && (!selectedSupplier || selectedSupplier?.value === 'default')) {
      setRoomState((prev) => ({ ...prev, searchedText: '' }));
    }
    // If current selection is a supplier room, clear its unread flag
    if (selectedSupplier?.value && selectedSupplier.value !== 'default') {
      setUnreadSuppliers((prev) => {
        const next = new Set(prev);
        next.delete(String(selectedSupplier.value));
        return next;
      });
    }
    // Clear unread for the active sample/PO as well
    const activeSampleId = selectedSample?._id || null;
    if (activeSampleId) {
      setUnreadSamples((prev) => {
        const next = new Set(prev);
        next.delete(String(activeSampleId));
        return next;
      });
    }
  }, [isExpanded, activeRoomName, selectedSupplier?.value, dispatch, selectedSample?._id]);

  // Reset sample & supplier dropdown when isExpanded is set to false
  useEffect(() => {
    if (!isExpanded) {
      if (isSupplierLoggedIn) {
        const loggedInSupplierOption = supplierOptions.find((option) => {
          return option.value === currentUser?.userId;
        });

        if (loggedInSupplierOption) {
          setSelectedSupplier(loggedInSupplierOption);
        } else {
          const firstSupplierOption = supplierOptions.find((option) => option.value !== 'default');
          setSelectedSupplier(firstSupplierOption || supplierOptions[0]);
        }
      } else {
        setSelectedSupplier({ label: t(chatLabel), value: 'default' });
      }
    }
  }, [isExpanded, isSupplierLoggedIn, supplierOptions, currentUser?.userId, t]);

  useEffect(() => {
    if (isSupplierLoggedIn) {
      const loggedInSupplierOption = supplierOptions.find((option) => {
        // Match supplier by userId when supplier is logged in
        return option.value === currentUser?.userId;
      });

      if (loggedInSupplierOption) {
        setSelectedSupplier(loggedInSupplierOption);
      } else {
        // If no match found, set to first supplier option (not default internal)
        const firstSupplierOption = supplierOptions.find((option) => option.value !== 'default');
        setSelectedSupplier(firstSupplierOption || supplierOptions[0]);
      }
    }
  }, [isSupplierLoggedIn, supplierOptions]);

  // Validate that selected supplier exists in current options, reset to default if not
  useEffect(() => {
    if (selectedSupplier && supplierOptions.length > 0) {
      const supplierExists = supplierOptions.some((option) => option.value === selectedSupplier.value);
      if (!supplierExists) {
        setSelectedSupplier({ label: t(chatLabel), value: 'default' });
      }
    }
  }, [selectedSupplier, supplierOptions, t, chatLabel]);

  // Fetch supplier users when supplier value changes
  useEffect(() => {
    const getSupplierUsers = async () => {
      const resp = await getSupplierUserById({ supplierId: selectedSupplier.value });
      const raw = Array.isArray(resp?.data) ? resp?.data : resp?.data?.data || [];
      return (raw || []).map((u) => ({
        id: u?._id,
        display: [u?.firstName, u?.lastName].filter(Boolean).join(' ') || u?.email || 'Supplier User',
        firstName: u?.firstName ?? '',
        lastName: u?.lastName ?? '',
        image: null,
        supplierUserAdded: true,
        supplierId: selectedSupplier.value,
      }));
    };

    (async () => {
      try {
        if (selectedSupplier?.value !== 'default' && selectedSupplier?.value !== undefined) {
          let supplierUsers = await getSupplierUsers();
          supplierUsers = supplierUsers.filter((user) => user.id.toString() !== String(currentUser?.supplierUserId));

          setRoomState((prev) => {
            const prevMentionsUsers = prev.mentionsUsers.filter((user) => user.supplierUserAdded !== true);
            let updatedMentionsUsers = [...prevMentionsUsers, ...supplierUsers];

            const isPrevSupplierExists = updatedMentionsUsers.some((user) => user.supplierDynamicallyAdded === true);
            if (isPrevSupplierExists) {
              updatedMentionsUsers = updatedMentionsUsers.filter((user) => user.supplierDynamicallyAdded !== true);
            }
            // For Supplier Admin
            if (!currentUser?.supplierUserId && currentUser?.userId !== selectedSupplier.value) {
              updatedMentionsUsers.push({
                id: selectedSupplier.value,
                display: selectedSupplier.label,
                firstName: selectedSupplier.label,
                lastName: '',
                image: null,
                supplierDynamicallyAdded: true,
              });
            }
            // For Supplier User
            if (currentUser?.supplierUserId && currentUser?.supplierUserId !== selectedSupplier.value) {
              updatedMentionsUsers.push({
                id: selectedSupplier.value,
                display: selectedSupplier.label,
                firstName: selectedSupplier.label,
                lastName: '',
                image: null,
                supplierDynamicallyAdded: true,
              });
            }

            return { ...prev, mentionsUsers: updatedMentionsUsers };
          });
        } else {
          setRoomState((prev) => {
            let updatedMentionsUsers = [...prev.mentionsUsers];
            const isPrevSupplierExists = updatedMentionsUsers.some((user) => user.supplierDynamicallyAdded === true || user.supplierUserAdded === true);
            if (isPrevSupplierExists) {
              updatedMentionsUsers = updatedMentionsUsers.filter((user) => user.supplierDynamicallyAdded !== true && user.supplierUserAdded !== true);
            }

            return { ...prev, mentionsUsers: updatedMentionsUsers };
          });
        }
      } catch (error) {
        console.error('Error fetching supplier users:', error);
      }
    })();
  }, [selectedSupplier?.value, selectedSupplier?.label, currentUser?.userId, currentUser?.supplierUserId]);

  useEffect(() => {
    if (isDetailsPage && Array.isArray(samplesList) && samplesList.length === 1) {
      setSelectedSample(samplesList[0]);
    } else if (Array.isArray(samplesList) && setSelectedSample) {
      const checkSelectedSample = samplesList.find((sample) => sample._id === selectedSample?._id);
      // if the selected sample is not in the samplesList, set the selected sample to null
      if (!checkSelectedSample) {
        setSelectedSample(null);
      }
    }
  }, [isDetailsPage, samplesList, setSelectedSample]);

  const shouldHideChatButton = useMemo(() => {
    if (moduleKey === 'BOM' || moduleKey === 'SPEC' || moduleKey === 'TESTING' || moduleKey === 'DESIGN_DETAIL' || moduleKey === 'CARE_USER_INSTRUCTION') {
      return false;
    }
    return isSupplierLoggedIn && (!Array.isArray(samplesList) || samplesList.length === 0);
  }, [moduleKey, samplesList, isSupplierLoggedIn]);

  const getModuleDisplayName = () => {
    switch (moduleKey) {
      case 'Costing':
        return 'Costing';
      case 'samples':
        return 'Sample';
      case 'placeholder':
        return 'Placeholder';
      case 'BOM':
        return 'BOM';
      case 'SPEC':
        return 'Specification';
      case 'TESTING':
        return 'TESTING';
      case 'DESIGN_DETAIL':
        return 'Design Detail';
      case 'CARE_USER_INSTRUCTION':
        return 'Care User Instruction';
      case 'PURCHASE_ORDER':
        return 'Purchase Order';
      default:
        return 'Chat';
    }
  };
  const getPlaceholderByModuleKey = () => {
    switch (moduleKey) {
      case 'Costing':
        return 'Select Costing';
      case 'samples':
        return 'Select Sample';
      case 'placeholder':
        return 'Select Placeholder';
      case 'PURCHASE_ORDER':
        return 'Select Purchase Order';
      default:
        return 'Select Chat';
    }
  };
  const getOptionLabelByModuleKey = (option) => {
    switch (moduleKey) {
      case 'Costing':
        return option?.productInfo?.reference || option?.reference || option?._id;
      case 'samples': {
        const sampleTypeName = option?.sampleType?.name || option?.sampleType;
        return sampleTypeName ? `${option?.sampleNumber} - ${sampleTypeName}` : option?.sampleNumber;
      }
      case 'PURCHASE_ORDER':
        return option?.purchaseOrderNumber || option?.poNumber || option?._id;
      default:
        return option?.name;
    }
  };
  const showMessageForModuleKey = () => {
    switch (moduleKey) {
      case 'Costing':
        return t('CHAT.ROOMS.SELECT_COSTING_TO_START_CHAT');
      case 'samples':
        return t('CHAT.ROOMS.SELECT_SAMPLE_TO_START_CHAT');
      case 'BOM':
        return t('CHAT.ROOMS.SELECT_BOM_TO_START_CHAT');
      case 'SPEC':
        return t('CHAT.ROOMS.SELECT_SPEC_TO_START_CHAT');
      case 'TESTING':
        return t('CHAT.ROOMS.SELECT_BOM_TO_START_CHAT');
      case 'DESIGN_DETAIL':
        return t('CHAT.ROOMS.SELECT_DESIGN_DETAIL_TO_START_CHAT');
      case 'CARE_USER_INSTRUCTION':
        return t('CHAT.ROOMS.SELECT_CARE_USER_INSTRUCTION_TO_START_CHAT');
      case 'PURCHASE_ORDER':
        return t('CHAT.ROOMS.SELECT_PURCHASE_ORDER_TO_START_CHAT');
      default:
        return t('CHAT.ROOMS.SELECT_PLACEHOLDER_TO_START_CHAT');
    }
  };

  useEffect(() => {
    const loadProductName = async () => {
      if (
        (moduleKey === 'SPEC' ||
          moduleKey === 'TESTING' ||
          moduleKey === 'DESIGN_DETAIL' ||
          moduleKey === 'CARE_USER_INSTRUCTION' ||
          moduleKey === 'PURCHASE_ORDER') &&
        isExpanded
      ) {
        await dispatch(fetchProductname(devOrderId));
      }
    };
    loadProductName();
  }, [moduleKey, devOrderId, isExpanded]);

  return (
    <div>
      {!shouldHideChatButton && (
        <button
          type="button"
          style={{ bottom: paddingBottom ? 60 : 20 }}
          aria-label="Toggle Chat"
          className={`${isExpanded ? 'chat-toggle-button expanded' : 'chat-toggle-button'}`}
          onClick={() => setRoomState((prev) => ({ ...prev, isExpanded: !prev.isExpanded, searchedText: '' }))}
        >
          {/* <i className="icon-Chat-toggle f-30" /> */}
          <img src={chatIcon} alt="Chat toggle" width={30} className="chat-toggle-icon" />
          {hasUnread && <img src={unreadBell} alt="Unread messages" className="unread-bell" />}
        </button>
      )}

      {isExpanded && (
        <div className="chat-content">
          {!['BOM', 'SPEC', 'TESTING', 'DESIGN_DETAIL', 'CARE_USER_INSTRUCTION', 'ProductInfoList'].includes(moduleKey) && (
            <div className="chat-header">
              {Array.isArray(samplesList) && samplesList.length === 0 && <p className="chat-landing-title">{getModuleDisplayName()}</p>}
              {Array.isArray(samplesList) && samplesList.length > 0 && (
                <div className="sample-selector">
                  <div>
                    <Select
                      options={samplesList}
                      value={selectedSample}
                      onChange={setSelectedSample}
                      getOptionLabel={(option) => getOptionLabelByModuleKey(option)}
                      getOptionValue={(option) => option._id}
                      className="common-select-chat"
                      classNamePrefix="common-select-chat"
                      styles={sampleSelectStyles}
                      placeholder={getPlaceholderByModuleKey()}
                      isClearable={!isDetailsPage}
                      isDisabled={isDetailsPage}
                      formatOptionLabel={(option) => (
                        <div className="chat-sample-option">
                          <span>{getOptionLabelByModuleKey(option)}</span>
                          {unreadSamples.has(String(option._id)) && <img src={unreadBell} alt="Unread messages" className="unread-bell" />}
                        </div>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
          {isSupplierRequired && (
            <div className="supplier-selector">
              <Select
                options={supplierOptions}
                value={selectedSupplier}
                onChange={(val) => setSelectedSupplier(val)}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                className="common-select-chat"
                classNamePrefix="common-select-chat"
                styles={supplierSelectStyles}
                placeholder={t('CHAT.ROOMS.GENERAL_CHAT')}
                isDisabled={isSupplierLoggedIn}
                formatOptionLabel={(option) => (
                  <div className="chat-supplier-option">
                    <span>{option.label}</span>
                    {option.value !== 'default' && unreadSuppliers.has(String(option.value)) && (
                      <img src={unreadBell} alt="Unread messages" className="unread-bell" />
                    )}
                  </div>
                )}
              />
            </div>
          )}
          <div className="chat-search">
            <i className="icon-Magnifying-Glass-Solid" />
            <input
              type="text"
              value={roomState.searchedText}
              disabled={activeRoomName === null}
              onChange={(e) => setRoomState((prev) => ({ ...prev, searchedText: e.target.value }))}
              className="form-control chat-search-input"
              placeholder={t('CHAT.SEARCH.PLACEHOLDER') || 'Search messages'}
              aria-label={t('CHAT.SEARCH.ARIA_LABEL') || 'Search chat messages'}
            />
          </div>
          {activeRoomName ? (
            <ChatRoomProvider key={activeRoomName} options={{ occupancy: { enableEvents: true } }} name={activeRoomName}>
              <ChatMessages
                currentUser={currentUser}
                roomName={activeRoomName}
                moduleRefId={selectedSample?._id || null}
                supplierId={selectedSupplier?.value || null}
                searchedText={debouncedSearch}
                mentionsUsers={roomState.mentionsUsers}
                productDetails={productDetails}
                onChatError={onChatError}
                onResetSamples={onResetSamples}
                onCloseChat={() => setRoomState((prev) => ({ ...prev, isExpanded: false }))}
                moduleKey={moduleKey}
              />
            </ChatRoomProvider>
          ) : (
            <div className="no-messages text-center mt-2">{showMessageForModuleKey()}</div>
          )}
        </div>
      )}
    </div>
  );
}

export default ChatRoom;
